/* Stockwave: makes sections converted from GemPages interactive — sliders, accordions, tabs, videos, animations.
   Owned by the theme; no outside scripts. */
(function () {
  if (window.__swgp) return; window.__swgp = 1;
  var A = function (x) { return Array.prototype.slice.call(x || []); };
  var own = function (root, sel, host) { return A(root.querySelectorAll(sel)).filter(function (e) { return e.closest(host) === root; }); };
  function data(el) {
    for (var i = 0; i < el.children.length; i++) { var c = el.children[i]; if (c.tagName === 'SCRIPT' && c.hasAttribute('gp-data')) { try { return JSON.parse(c.textContent || '{}'); } catch (e) { return {}; } } }
    return {};
  }
  function bp() { var w = window.innerWidth; return w < 768 ? 'mobile' : w < 1025 ? 'tablet' : 'desktop'; }
  function rv(o, d) {
    if (o == null || typeof o !== 'object' || Array.isArray(o)) return o == null ? d : o;
    var b = bp(), v = b === 'mobile' ? (o.mobile != null ? o.mobile : o.tablet != null ? o.tablet : o.desktop) : b === 'tablet' ? (o.tablet != null ? o.tablet : o.desktop) : o.desktop;
    return v == null ? d : v;
  }
  function colour(v, d) { if (!v) return d; v = String(v); return /^(#|rgb|hsl|transparent|var\()/.test(v) ? v : 'var(--g-c-' + v + ', ' + d + ')'; }
  var done = typeof WeakSet !== 'undefined' ? new WeakSet() : { has: function () { return false; }, add: function () {} };
  function once(el) { if (done.has(el)) return false; done.add(el); return true; }

  // ── images, videos, styles GemPages switched on with its own script ──
  function media(root) {
    A(root.querySelectorAll('.gps-lazy')).forEach(function (e) { e.classList.remove('gps-lazy'); });
    A(root.querySelectorAll('style[type="text/disabled-css"]')).forEach(function (s) { s.removeAttribute('type'); });
    A(root.querySelectorAll('img[data-src]')).forEach(function (i) { if (!i.getAttribute('src')) i.setAttribute('src', i.getAttribute('data-src')); });
    A(root.querySelectorAll('img[data-srcset],source[data-srcset]')).forEach(function (i) { if (!i.getAttribute('srcset')) i.setAttribute('srcset', i.getAttribute('data-srcset')); });
    var vids = A(root.querySelectorAll('video[data-src]'));
    var load = function (v) {
      if (!v.getAttribute('src')) { v.setAttribute('src', v.getAttribute('data-src')); }
      var p = v.getAttribute('data-poster'); if (p && !v.getAttribute('poster')) v.setAttribute('poster', p);
      if (v.hasAttribute('autoplay')) { v.muted = true; v.setAttribute('muted', ''); var pr = v.play && v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } }); }, { rootMargin: '300px' });
      vids.forEach(function (v) { if (once(v)) io.observe(v); });
    } else vids.forEach(load);
  }

  // ── accordions ──
  function accordion(acc) {
    if (!once(acc)) return;
    var s = data(acc).setting || {};
    var items = own(acc, '.gp-accordion-item', 'gp-accordion');
    var single = s.expandedMode === 'single';
    function set(item, open) {
      var body = own(acc, '.gp-accordion-item_body', 'gp-accordion').filter(function (b) { return b.closest('.gp-accordion-item') === item; })[0];
      if (!body) return;
      body.setAttribute('data-show', open ? 'true' : 'false');
      body.style.gridTemplateRows = open ? '1fr' : '0fr';
      body.classList.toggle('gp-grid-rows-[1fr]', open); body.classList.toggle('gp-grid-rows-[0fr]', !open);
      var icon = item.querySelector('.gp-accordion-item_icon');
      if (icon) {
        if (s.iconExpand && s.iconCollapse && !s.isIconPlus) icon.innerHTML = open ? s.iconExpand : s.iconCollapse;
        else icon.style.transform = open ? 'rotate(180deg)' : '';
      }
      var head = item.querySelector('.gp-accordion-item_header'); if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    items.forEach(function (item) {
      var head = own(acc, '.gp-accordion-item_header', 'gp-accordion').filter(function (h) { return h.closest('.gp-accordion-item') === item; })[0];
      if (!head) return;
      head.removeAttribute('aria-hidden'); head.setAttribute('role', 'button'); head.setAttribute('tabindex', '0');
      var body = item.querySelector('.gp-accordion-item_body');
      set(item, !!body && body.getAttribute('data-show') === 'true');
      var toggle = function () {
        var open = !(body && body.getAttribute('data-show') === 'true');
        if (open && single) items.forEach(function (o) { if (o !== item) set(o, false); });
        set(item, open);
      };
      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }

  // ── tabs ──
  function tabs(tab) {
    if (!once(tab)) return;
    var s = data(tab).setting || {};
    var heads = own(tab, '.gp-tab-header-list > li', 'gp-tab');
    var panels = own(tab, '.gp-tab-item-container > .gp-tab-item', 'gp-tab');
    if (!heads.length) return;
    var c = s.labelColor || {}, bg = s.labelBgColor || {};
    function show(i) {
      heads.forEach(function (h, k) {
        var on = k === i;
        h.classList.toggle('sw-tab-active', on); h.setAttribute('aria-selected', on ? 'true' : 'false');
        if (c.active || c.normal) h.style.setProperty('--c', on ? colour(c.active, 'inherit') : colour(c.normal, 'inherit'));
        if (bg.active || bg.normal) h.style.setProperty('--bgc', on ? colour(bg.active, 'transparent') : colour(bg.normal, 'transparent'));
      });
      panels.forEach(function (p, k) {
        var on = k === i;
        ['--v', '--v-tablet', '--v-mobile'].forEach(function (v) { p.style.setProperty(v, on ? 'visible' : 'hidden'); });
        ['--pos', '--pos-tablet', '--pos-mobile'].forEach(function (v) { p.style.setProperty(v, on ? 'relative' : 'absolute'); });
        p.style.pointerEvents = on ? '' : 'none'; p.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }
    heads.forEach(function (h, k) {
      h.removeAttribute('aria-hidden'); h.setAttribute('role', 'tab'); h.setAttribute('tabindex', '0');
      h.addEventListener('click', function () { show(k); });
      h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(k); } });
    });
    var first = Number(s.activeKey) || 0; show(first < heads.length ? first : 0);
  }

  // ── sliders (gp-carousel, gp-carousel-v3) ──
  function carousel(car) {
    if (!once(car)) return;
    var s = (data(car).setting) || {};
    var track = own(car, '.gem-slider', 'gp-carousel, gp-carousel-v3')[0];
    if (!track) return;
    var items = A(track.children).filter(function (e) { return e.classList.contains('gem-slider-item'); });
    if (!items.length) return;
    track.classList.add('sw-slider');
    var gap = function () { var g = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap); return isNaN(g) ? 0 : g; };
    var per = function () { return Math.max(1, Number(rv(s.itemNumber, 1)) || 1); };
    var step = function () { return items[0].getBoundingClientRect().width + gap(); };
    var pages = function () { return Math.max(1, items.length - Math.floor(per()) + 1); };
    var at = function () { return Math.round(track.scrollLeft / Math.max(1, step())); };
    var loop = !!rv(s.loop, false) || !!s.autoplay;
    function go(i) {
      var n = pages(); if (i < 0) i = loop ? n - 1 : 0; if (i >= n) i = loop ? 0 : n - 1;
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }
    own(car, '.gem-slider-previous', 'gp-carousel, gp-carousel-v3').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); go(at() - 1); }); });
    own(car, '.gem-slider-next', 'gp-carousel, gp-carousel-v3').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); go(at() + 1); }); });
    // dots
    var dotBox = own(car, '.gp-carousel-dot-container', 'gp-carousel, gp-carousel-v3')[0];
    var dots = [];
    function drawDots() {
      if (!dotBox) return;
      var show = rv(s.dot, false); dotBox.style.display = show && pages() > 1 ? '' : 'none';
      dotBox.innerHTML = ''; dots = [];
      var size = Number(rv(s.dotSize, 12)) || 12;
      for (var i = 0; i < pages(); i++) {
        var d = document.createElement('button'); d.type = 'button'; d.className = 'sw-dot'; d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.style.width = d.style.height = size + 'px';
        (function (k) { d.addEventListener('click', function () { go(k); }); })(i);
        dotBox.appendChild(d); dots.push(d);
      }
      paint();
    }
    function paint() {
      var cur = at(), on = colour(rv(s.dotActiveColor, '#121212'), '#121212'), off = colour(rv(s.dotColor, '#d1d1d1'), '#d1d1d1');
      dots.forEach(function (d, k) { d.style.background = k === cur ? on : off; d.style.opacity = k === cur ? '1' : '.6'; });
    }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(paint, 60); }, { passive: true });
    drawDots();
    var lastBp = bp(); window.addEventListener('resize', function () { if (bp() !== lastBp) { lastBp = bp(); drawDots(); } });
    // autoplay
    if (s.autoplay) {
      var ms = Math.max(1, Number(s.autoplayTimeout) || 3) * 1000, paused = false, timer = null;
      var tick = function () { if (!paused && document.visibilityState !== 'hidden') go(at() + 1); };
      var start = function () { if (!timer) timer = setInterval(tick, ms); };
      if (s.pauseOnHover !== false) { car.addEventListener('mouseenter', function () { paused = true; }); car.addEventListener('mouseleave', function () { paused = false; }); }
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      track.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, ms); }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) start(); else { clearInterval(timer); timer = null; } }); }).observe(car);
      else start();
    }
    // drag with the mouse (touch scrolls natively)
    if (rv(s.enableDrag, true) !== false) {
      var down = false, x0 = 0, l0 = 0, moved = false;
      track.addEventListener('mousedown', function (e) { down = true; moved = false; x0 = e.pageX; l0 = track.scrollLeft; track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto'; });
      window.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - x0; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = l0 - dx; });
      window.addEventListener('mouseup', function () { if (!down) return; down = false; track.style.scrollSnapType = ''; track.style.scrollBehavior = ''; go(at()); });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      A(track.querySelectorAll('img,a')).forEach(function (i) { i.setAttribute('draggable', 'false'); });
    }
  }

  // ── hero banner: the whole banner is a link ──
  function hero(h) {
    if (!once(h)) return;
    var s = data(h).setting || data(h) || {};
    // "original" shape: the banner is as tall as its background picture (GemPages measured it with its script)
    var box = h.querySelector('.hero-banner-container'), size = s.sizeSetting || {};
    if (box) [['desktop', '--aspect', ':not(.gp_lazybg_tl):not(.gp_lazybg_mb)'], ['tablet', '--aspect-tablet', '.gp_lazybg_tl'], ['mobile', '--aspect-mobile', '.gp_lazybg_mb']].forEach(function (b) {
      var sz = size[b[0]] || (b[0] === 'mobile' ? size.tablet || size.desktop : size.desktop) || {};
      if (sz.shape && sz.shape !== 'original') return;
      var cur = box.style.getPropertyValue(b[1]).trim(); if (cur && cur !== 'auto') return;
      var bg = s.background || {}, bi = ((bg[b[0]] || bg.tablet || bg.desktop || {}).image) || {};
      var img = box.querySelector('img.gp_lazyforbg' + b[2]) || box.querySelector('img.gp_lazyforbg');
      var apply = function () {
        var w = (img && img.naturalWidth) || Number(bi.width) || (img && Number(img.getAttribute('width'))), hh = (img && img.naturalHeight) || Number(bi.height) || (img && Number(img.getAttribute('height')));
        if (w && hh) box.style.setProperty(b[1], w + '/' + hh);
      };
      apply(); if (img && !img.complete) img.addEventListener('load', apply);
    });
    var href = s.href; if (!href) return;
    A(h.querySelectorAll('[data-hero-banner-link]')).forEach(function (el) {
      el.addEventListener('click', function (e) { if (e.target.closest('a,button')) return; if (s.target === '_blank') window.open(href, '_blank', 'noopener'); else location.href = href; });
    });
  }

  // ── animations (slide / fade / zoom in when they scroll into view) ──
  function animation(a) {
    if (!once(a)) return;
    var cfg = (data(a).config || {}), c = rv(cfg, cfg.desktop) || {};
    var inner = A(a.children).filter(function (e) { return e.tagName !== 'SCRIPT'; })[0];
    if (!inner) return;
    var show = function () { ['--v', '--v-tablet', '--v-mobile'].forEach(function (v) { inner.style.setProperty(v, 'visible'); }); };
    var ap = c.enabled && c.triggerConfig && c.triggerConfig.appear, kind = ap && ap.animation, set = ap && ap.setting && ap.setting[kind];
    if (!kind || kind === 'none' || !set || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { show(); return; }
    var targets = A(inner.children);
    var run = function () {
      show();
      targets.forEach(function (t) {
        var dir = set.direction || 'up', dist = (Number(set.distance) || 100) / 2 + 'px';
        if (kind === 'slide') { t.style.setProperty('--sw-dx', dir === 'left' ? dist : dir === 'right' ? '-' + dist : '0'); t.style.setProperty('--sw-dy', dir === 'down' ? '-' + dist : dir === 'up' ? dist : '0'); }
        if (kind === 'zoom') t.style.setProperty('--sw-sc', set.zoomDirection === 'out' ? '1.15' : '.85');
        t.style.animation = 'sw-gp-in ' + (Number(set.speed) || 1) + 's ' + (set.easing || 'ease-out') + ' ' + (Number(set.delay) || 0) + 's both';
      });
    };
    var box = targets.filter(function (t) { return getComputedStyle(t).display !== 'contents'; })[0];   // gp-animation itself has no box (display: contents)
    if (box && 'IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); run(); } }); }, { threshold: 0.15 }); io.observe(box); }
    else run();
  }

  // ── nothing empty on the page: blank buttons, blank banners, slides with nothing in them, and whole sections
  //    whose pictures and words were all left empty are hidden ──
  function hasBg(el) { return A(el.querySelectorAll('[style*="--bgi"]')).concat([el]).some(function (x) { var m = (x.getAttribute('style') || '').match(/--bgi[\w-]*:\s*url\(\s*['"]?([^)'"\s]+)/); return !!(m && m[1]); }); }
  function filled(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, { acceptNode: function (n) { var p = n.parentNode && n.parentNode.nodeName; return p === 'SCRIPT' || p === 'STYLE' || p === 'TEMPLATE' || !/\S/.test(n.nodeValue) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; } });
    if (w.nextNode()) return true;
    if (A(el.querySelectorAll('img')).some(function (i) { var s = i.getAttribute('src') || i.getAttribute('data-src') || ''; return s && !/^data:|^\s*$/.test(s) && !i.classList.contains('gp_lazyforbg'); })) return true;
    if (el.querySelector('video[src],video[data-src],iframe[src]')) return true;
    return hasBg(el);
  }
  function tidy(sec) {
    A(sec.querySelectorAll('gp-button')).forEach(function (b) {
      var t = b.querySelector('a,button'); var text = t && (t.textContent || '').trim(); var icon = t && t.querySelector('svg,img');
      if (t && !text && !icon) b.style.display = 'none';
    });
    A(sec.querySelectorAll('gp-hero-banner')).forEach(function (h) { if (!filled(h)) h.style.display = 'none'; });
    A(sec.querySelectorAll('.gem-slider-item')).forEach(function (s) { if (!filled(s)) s.remove(); });
    A(sec.querySelectorAll('gp-carousel, gp-carousel-v3, gp-accordion, gp-tab')).forEach(function (c) { if (!filled(c)) c.style.display = 'none'; });
    if (!filled(sec)) { sec.style.display = 'none'; sec.setAttribute('data-sw-empty', ''); }
  }

  function init(root) {
    root = root || document;
    var secs = root.querySelectorAll ? A(root.querySelectorAll('.gps')) : [];
    if (root.classList && root.classList.contains('gps')) secs.push(root);
    secs.forEach(function (sec) {
      media(sec);
      if (!(window.Shopify && window.Shopify.designMode)) tidy(sec);   // in the theme editor, keep blanks visible so they can be filled
      A(sec.querySelectorAll('gp-accordion')).forEach(accordion);
      A(sec.querySelectorAll('gp-tab')).forEach(tabs);
      A(sec.querySelectorAll('gp-carousel, gp-carousel-v3')).forEach(carousel);
      A(sec.querySelectorAll('gp-hero-banner')).forEach(hero);
      A(sec.querySelectorAll('gp-animation')).forEach(animation);
    });
  }
  window.StockwaveGP = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  // theme editor: sections are re-rendered in place
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
